/*
 * @Author: Teemo Ding
 * @Date: 2021-09-03 11:16:20
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-11-23 13:28:58
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/StatusTag/index.tsx
 */
import React from 'react';
import { EnumStatus } from 'src/types/common/discount';
import css from './css.module.less';
import { getI18nFromGeneral } from '@/src/tools/tools';

const StatusTag = ({ status }) => {
  const tagColor = {
    [EnumStatus.Active]: {
      color: '#52C41A',
      backgroundColor: '#F6FFED',
      label: getI18nFromGeneral('general.status.active'),
    },
    [EnumStatus.Draft]: {
      color: '#FAAD14',
      backgroundColor: '#FFFBE6',
      label: getI18nFromGeneral('general.status.draft'),
    },
    [EnumStatus.Scheduled]: {
      color: '#1B93C5',
      backgroundColor: '#F4FCFF',
      label: getI18nFromGeneral('general.status.scheduled'),
    },
    [EnumStatus.Issued]: {
      color: '#1B93C5',
      backgroundColor: '#F4FCFF',
      label: getI18nFromGeneral('general.status.issued'),
    },
    [EnumStatus.Expired]: {
      color: '#5C6269',
      backgroundColor: '#F4F5F7',
      label: getI18nFromGeneral('general.status.expired'),
    },
    [EnumStatus.Archived]: {
      color: '#5C6269',
      backgroundColor: '#F4F5F7',
      label: getI18nFromGeneral('general.status.archived'),
    },
    [EnumStatus.ZeroBalance]: {
      color: '#5C6269',
      backgroundColor: '#F4F5F7',
      label: getI18nFromGeneral('general.statusTag.zero_balance'),
    },
    [EnumStatus.Used]: {
      color: '#5C6269',
      backgroundColor: '#F4F5F7',
      label: getI18nFromGeneral('general.status.used'),
    },
    [EnumStatus.Locked]: {
      color: '#5C6269',
      backgroundColor: '#F4F5F7',
      label: getI18nFromGeneral('general.status.locked'),
    },
  };
  const t = tagColor[status] || {};
  return (
    <div
      className={css.statusTag}
      style={{
        ...t,
        border: `1px solid ${t.color}`,
      }}>
      {t.label}
    </div>
  );
};

export default StatusTag;
